import { render, staticRenderFns } from "./AppointmentsListContainer.vue?vue&type=template&id=74a5c6f7&scoped=true&"
import script from "./AppointmentsListContainer.vue?vue&type=script&lang=js&"
export * from "./AppointmentsListContainer.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentsListContainer.vue?vue&type=style&index=0&id=74a5c6f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a5c6f7",
  null
  
)

export default component.exports